import React, { useState } from "react";
import Loading from "../../../../Components/Interactive/Loading";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ReportHistoryTable from "./ReportHistory/ReportHistoryTable";

const CustomerReportHistoryWidget = ({ allCustomerData, loading }) => {
  const {
    userReportHistory: { history },
  } = allCustomerData;
  const [open, setIsOpen] = useState(false);
  const [toggleDropdown, setToggleDropdown] = useState(false);
  const totalReportsHeading = (history.customerReportHistoryCount ? history.customerReportHistoryCount : 0) + 
                              (history.phoneReportHistoryCount ? history.phoneReportHistoryCount : 0) + 
                              (history.socialReportHistoryCount ? history.socialReportHistoryCount : 0) +
                              (history.propertyReportHistoryCount ? history.propertyReportHistoryCount : 0) +
                              (history.autoReportHistoryCount ? history.autoReportHistoryCount : 0);
  return (
    <div className="user-data-container" style={{marginBottom: "1rem"}}>
      {loading ? (
        <div className="loading-widget">
          <Loading />
        </div>
      ) : (
        <>
          <div className="customer-widget-header">
            <p
              className="customer-widget-heading"
              style={{ width: "100%", padding: ".5rem .5rem" }}
            >
              Report History
              <ArrowDropDownIcon
                onClick={() => {
                  setIsOpen(!open);
                  setToggleDropdown(!toggleDropdown);
                }}
                className={`arrow-dropdown ${
                  toggleDropdown ? "arrow-open" : "arrow-close"
                }`}
              />
            </p>
            {!open && (
              <p className="closed-details-text"
              >
                Total Reports - {totalReportsHeading}
              </p>
            )}
          </div>
          <div
            className={`${
              open ? "show-data-table-call" : "no-data-table-call"
            }`}
          >
            {history && (
              <ReportHistoryTable historyData={history} open={open} />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default CustomerReportHistoryWidget;
